import React from 'react';
import {
  Box, Typography
} from '@material-ui/core';

import { PERSPECTIVE_ID, WIDGET_TYPE } from 'src/views/constants/perspectiveConstants';
import MiniCard from 'src/components/MiniCard';

const WidgetCard = ({
  label,
  widgetType,
  description,
  icon,
  header,
  perspectiveId,
  setIsDragging
}: any) => {
  if (header) {
    return (
      <Box mt={4}>
        <Typography variant="h4">
          {header}
        </Typography>
      </Box>
    );
  }

  return (
    <div
      id={widgetType}
      className="droppable-element"
      draggable
      unselectable="on"
      onDragStart={(e) => {
        e.dataTransfer.setData(WIDGET_TYPE, widgetType);
        e.dataTransfer.setData(PERSPECTIVE_ID, perspectiveId);
        localStorage.setItem(WIDGET_TYPE, widgetType);
      }}
    >
      <MiniCard
        icon={icon}
        label={label}
        description={description}
      />
    </div>
  );
};

export default WidgetCard;
